import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { INITIAL_EXPERTS_AMOUNT } from '@packages/shared/core/common/constants/appDefaults';
import { FlowName } from '@packages/shared/core/quiz/entities';
import { ExpertRequestFilter } from '../entities';
import {
  currentExpertUpdated,
  fetchAllExperts,
  fetchInitialExperts,
  getExperts,
  getExpertsStatus,
  getInitialExpertsStatus,
  getSelectedExpert,
} from '../store';

export function useExperts({
  initialExpertsAmount = INITIAL_EXPERTS_AMOUNT,
  flowName,
  filter,
}: {
  initialExpertsAmount?: number;
  flowName: FlowName;
  filter?: ExpertRequestFilter;
}) {
  const dispatch = useDispatch();

  const experts = useSelector(getExperts);
  const loadingInitialExpertsStatus = useSelector(getInitialExpertsStatus);
  const loadingAllExpertsStatus = useSelector(getExpertsStatus);
  const selectedExpert = useSelector(getSelectedExpert);

  const doFetchInitialExperts = useCallback(() => {
    dispatch(
      fetchInitialExperts({
        perPage: initialExpertsAmount,
        customerSource: flowName,
        filter,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, initialExpertsAmount, flowName]);

  const doFetchAllExperts = useCallback(() => {
    dispatch(fetchAllExperts({ customerSource: flowName, filter }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, flowName]);

  const doCurrentExpertUpdated = useCallback(
    (id: string) => {
      dispatch(currentExpertUpdated(id));
    },
    [dispatch],
  );

  return {
    experts,
    loadingInitialExpertsStatus,
    loadingAllExpertsStatus,
    fetchInitialExperts: doFetchInitialExperts,
    fetchAllExperts: doFetchAllExperts,
    currentExpertUpdated: doCurrentExpertUpdated,
    selectedExpert,
  };
}
